export default __webpack_public_path__ + "static/media/discord_logo_white.0b3d7d68.svg";